export const authErrors = {
  REAUTHENTICATE: {
    status: 401,
    code: 'REAUTHENTICATE',
    title: 'Authentication Error',
    subtitle: 'PLEASE REAUTHENTICATE',
    description: 'There was an issue connecting to this application. Please re-authenticate. If the issue persists, contact support for further assistance.',
    actions: ['reauthenticate'],
    component: 'DefaultErrorPage'
  },
  MISSING_REFRESH_TOKEN: {
    status: 401,
    code: 'MISSING_REFRESH_TOKEN',
    title: 'Authentication Error',
    subtitle: 'AUTHENTICATION ISSUE',
    description: 'There was an issue with authentication, possibly due to expired credentials. Please try logging in again. If the issue persists, contact support for further assistance.',
    roles: {
      admin: {
        title: 'Missing Refresh Token Functionality',
        subtitle: 'REFRESH TOKEN ERROR',
        description: 'The application may not be configured to provide a refresh token, or the refresh token was not included in the credentials. Please verify your application settings and ensure refresh tokens are properly enabled and configured.',
        about: {
          title: 'More on this error',
          description: 'OAuth 2.0 allows for the use of refresh tokens to renew access tokens when they expire. If this functionality is not supported at the app level, credentials will need to be manually updated or the app must be re-designed to include this feature.',
          link: { text: 'Learn More', url: 'https://mindcloud.co/docs/gravity/auth/oauth-20' }
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  REFRESH_TOKEN_FAILURE: {
    status: 401,
    code: 'REFRESH_TOKEN_FAILURE',
    title: 'Authentication Error',
    subtitle: 'AUTHENTICATION ISSUE',
    description: 'There was an issue with authentication, possibly due to expired credentials. Please try logging in again. If the issue persists, contact support for further assistance.',
    roles: {
      admin: {
        title: 'Failed to Fetch New Tokens',
        subtitle: 'REFRESH TOKEN ERROR',
        description: 'The system failed to retrieve new tokens using the refresh token. This can occur due to invalid or expired refresh tokens, or misconfiguration in the OAuth setup.',
        about: {
          title: 'More on this error',
          description: 'This error occurs when the system is unable to refresh the access token using the provided refresh token. Common causes include expired refresh tokens, invalid tokens, an issue with the OAuth configuration in the app screen or it could also be at the application side, not gravity, the application you are trying to connect could have a feature called "Token rotation", it is possible you need to enable this feature.',
          link: { text: 'Learn More', url: 'https://mindcloud.co/docs/gravity/auth/oauth-20' }
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  NO_CREDENTIAL_FOUND: {
    status: 400,
    code: 'NO_CREDENTIAL_FOUND',
    title: 'No Connection Found',
    subtitle: 'AUTHENTICATION ISSUE',
    description: 'This step has no valid connection associated with it. Please check the Authenticate tab.',
    component: 'DefaultErrorPage'
  },
  SAME_REFRESH_TOKEN: {
    status: 401,
    code: 'SAME_REFRESH_TOKEN',
    title: 'Authentication Error',
    subtitle: 'AUTHENTICATION ISSUE',
    description: 'There was an issue with authentication, possibly due to expired credentials. Please try logging in again. If the issue persists, contact support for further assistance.',
    roles: {
      admin: {
        title: 'Tokens Did Not Change',
        subtitle: 'REFRESH TOKEN ERROR',
        description: 'The system successfully refreshed the token, but the new token is identical to the old one. This may indicate a problem with the app’s implementation of refresh token functionality.',
        about: {
          title: 'More on this error',
          description: 'OAuth 2.0 refresh tokens are expected to return new access tokens when invoked. If the token remains unchanged after a successful refresh request, the app’s implementation of refresh token functionality should be reviewed.',
          link: { text: 'Learn More', url: 'https://mindcloud.co/docs/gravity/auth/oauth-20' }
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  SAME_AUTH_TOKEN: {
    status: 401,
    code: 'SAME_AUTH_TOKEN',
    title: 'Authentication Error',
    subtitle: 'AUTHENTICATION ISSUE',
    description: 'There was an issue with authentication, possibly due to expired credentials. Please try logging in again. If the issue persists, contact support for further assistance.',
    roles: {
      admin: {
        title: 'Auth Token Did Not Change',
        subtitle: 'AUTH TOKEN ERROR',
        description: "The system successfully authenticated, but the new auth token is identical to the old one. This may indicate a problem with the app's implementation of authentication functionality.",
        about: {
          title: 'More on this error',
          description: "Authentication tokens are expected to be unique for each authentication request. If the token remains unchanged after a successful authentication request, the app's implementation of authentication functionality should be reviewed.",
          link: { text: 'Learn More', url: 'https://mindcloud.co/docs/gravity/auth/oauth-20' }
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  AUTH_TEST_FAILED: {
    status: 401,
    code: 'AUTH_TEST_FAILED',
    title: 'Invalid Connection',
    subtitle: 'AUTHENTICATION ISSUE',
    description: 'Some workflow connections are either invalid or missing. This can occur if the API key, token, or other required values are incorrect or not supplied. Please review the connections listed below and try again.',
    component: 'DefaultErrorPage',
    showResponseBody: true
  },
  ORPHANED_CREDENTIALS: {
    status: 400,
    code: 'ORPHANED_CREDENTIALS',
    title: 'Orphaned Connection',
    subtitle: 'AUTHENTICATION ISSUE',
    description: 'Some connection referenced in this workflow have since been deleted. Please update any step that references these connections and try again.',
    component: 'DefaultErrorPage',
    showResponseBody: true
  }
};
